<template>
  <div class="punch">
    <div class="searchRow">
      <!-- <el-input class="tableSearch" v-model="searchInfo" placeholder="标题内容搜索"></el-input> -->
      <!-- <el-date-picker class="tableSearch" value-format="yyyy-MM" v-model="searchMounth" type="month" placeholder="选择月"></el-date-picker> -->
      <!-- <el-select clearable class="tableSearch" v-model="searchClass" placeholder="请选择搜索部门">
        <el-option
          v-for="item in classList"
          :key="item.department_id"
          :label="item.department_name"
          :value="item.department_id"
        ></el-option>
      </el-select>-->
      <el-date-picker
        v-model="start_time"
        type="date"
        style="margin-right:0"
        class="tableSearch"
        placeholder="开始时间"
        value-format="yyyy-MM-dd"
        :picker-options="pickerOptionsStart"
      ></el-date-picker>
      <span style="line-height:48px;margin:0 15px;color:#666">至</span>
      <el-date-picker
        v-model="end_time"
        type="date"
        class="tableSearch"
        placeholder="结束时间"
        value-format="yyyy-MM-dd"
        :picker-options="pickerOptionsEnd"
      ></el-date-picker>
      <el-cascader
        :modal-append-to-body="false"
        class="tableSearch"
        v-model="searchClassArr"
        filterable
        clearable
        @change="handleCasSearchChange"
        :options="selectClassList"
        :props="{ value:'department_id', label:'department_name', checkStrictly: true}"
        placeholder="请选择搜索部门"
      ></el-cascader>
      <one-selected @my-one-change="handleSearchPeopleChange"></one-selected>
      <div class="btnCol">
        <el-button class="search" @click="handleSearch">查询</el-button>
        <el-button class="creat" style="background-color:#40A0F2;" @click="handleOut">导出</el-button>
      </div>
    </div>
    <el-table
      :header-cell-style="{background:'#40A0F2', padding:'20px 0',color:'#fff',fontSize:'18px',fontWeight:'400'}"
      :cell-style="{borderBottom:'none', color:'#333',fontSize:'16px',padding:'13px 0',fontWeight:'400'}"
      :data="tableData"
      stripe
      height="calc(100% - 68px - 20px - 50px)"
      style="width: 100%; margin-top:20px"
    >
      <!-- 姓名 -->
      <el-table-column prop="nickname" :show-overflow-tooltip="true" align="center" label="姓名"></el-table-column>
      <!-- 出勤次数 -->
      <el-table-column :show-overflow-tooltip="true" align="center" label="出勤次数">
        <template slot-scope="scope">
          <span
            @click="getDetailsList('ClockInStatistics/attendance_list',scope.row,'出勤')"
            class="currentnumber"
          >{{scope.row.statistics.cq_count}}</span>
        </template>
      </el-table-column>
      <!-- 迟到次数 -->
      <el-table-column :show-overflow-tooltip="true" align="center" label="迟到次数">
        <template slot-scope="scope">
          <span
            @click="getDetailsList('ClockInStatistics/late_list',scope.row,'迟到')"
            class="currentnumber"
          >{{scope.row.statistics.cd_count}}</span>
        </template>
      </el-table-column>
      <!-- 早退 -->
      <el-table-column :show-overflow-tooltip="true" align="center" label="早退">
        <template slot-scope="scope">
          <span
            @click="getDetailsList('ClockInStatistics/early_list',scope.row,'早退')"
            class="currentnumber"
          >{{scope.row.statistics.zt_count}}</span>
        </template>
      </el-table-column>
      <!-- 旷工 -->
      <el-table-column :show-overflow-tooltip="true" align="center" label="旷工">
        <template slot-scope="scope">
          <span
            @click="getDetailsList('ClockInStatistics/absenteeism_list',scope.row,'旷工')"
            class="currentnumber"
          >{{scope.row.statistics.kg_count}}</span>
        </template>
      </el-table-column>
      <!-- 缺卡 -->
      <el-table-column :show-overflow-tooltip="true" align="center" label="缺卡">
        <template slot-scope="scope">
          <span
            @click="getDetailsList('ClockInStatistics/card_replacement_list',scope.row,'缺卡')"
            class="currentnumber"
          >{{scope.row.statistics.bk_count}}</span>
        </template>
      </el-table-column>
      <!-- 请假 -->
      <el-table-column :show-overflow-tooltip="true" align="center" label="请假">
        <template slot-scope="scope">
          <span
            @click="getDetailsList('ClockInStatistics/leave_list',scope.row,'请假')"
            class="currentnumber"
          >{{scope.row.statistics.qj_count}}</span>
        </template>
      </el-table-column>
    </el-table>
    <div class="pageRow" v-if="tableData.length>0">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        background
        :page-sizes="[5, 10, 15, 20, 30]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </div>
    <el-dialog
      :visible.sync="dialogVisible"
      width="50%"
      class="checkDia"
      :before-close="handleClose"
      @close="handleClosed"
      v-dialogDrag
    >
      <div slot="title" class="header-title">
        <span class="title-name" style="color:#128BF1;margin-right:5px">{{checkName}}</span>
        <span class="title-age">{{'的' + statusShow + '记录'}}</span>
      </div>
      <div class="diaContainer">
        <el-table
          :header-cell-style="{background:'#40A0F2', padding:'20px 0',color:'#fff',fontSize:'18px',fontWeight:'400'}"
          :cell-style="{borderBottom:'none', color:'#333',fontSize:'16px',padding:'13px 0',fontWeight:'400'}"
          :data="tableData2"
          stripe
          height="33vh"
          style="width: 100%; margin-top:20px"
        >
          <el-table-column
            :show-overflow-tooltip="true"
            align="center"
            label="考勤时间"
            v-if="statusShow!='请假'"
          >
            <template slot-scope="scope">
              <span>{{scope.row.day+' 星期'+scope.row.week}}</span>
              <!-- <span v-if="scope.row.time">{{scope.row.time}}</span> -->
            </template>
          </el-table-column>
          <el-table-column
            :show-overflow-tooltip="true"
            align="center"
            label="请假时间"
            v-if="statusShow=='请假'"
          >
            <template slot-scope="scope">
              <span>{{scope.row.start_time+'-'+scope.row.end_time}}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="statusShow"
            :show-overflow-tooltip="true"
            align="center"
            label="考勤结果"
          ></el-table-column>
          <el-table-column
            :show-overflow-tooltip="true"
            v-if="statusShow=='缺卡'"
            align="center"
            label="缺卡班次"
          >
            <template slot-scope="scope">
              <span>{{scope.row.day}}</span>
              <span style="margin-left:10px" v-if="scope.row.time">{{scope.row.time}}</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import OneSelected from '../../../components/OneSelected'

export default {
  data() {
    return {
      checkName: '',
      searchInfo: '',
      searchUserId: '',
      searchClass: '',
      searchMounth: '',
      searchClassArr: [],
      selectClassList: [],
      tableData: [],
      tableData2: [],
      currentPage: 1,
      pageSize: 10,
      total: 0,
      dialogVisible: false,
      statusShow: '',
      start_time: '',
      end_time: '',
      pickerOptionsStart: {
        disabledDate: (time) => {
          if (this.end_time) {
            return (
              time.getTime() > new Date(this.end_time).getTime() ||
              time.getTime() > Date.now() - 8.64e6
            )
          } else {
            return time.getTime() > Date.now() - 8.64e6
          }
        },
      },
      pickerOptionsEnd: {
        disabledDate: (time) => {
          if (this.start_time) {
            return (
              time.getTime() < new Date(this.start_time).getTime() - 86400000 ||
              time.getTime() > Date.now() - 8.64e6
            )
          } else {
            return time.getTime() > Date.now() - 8.64e6
          }
        },
      },
    }
  },
  components: {
    OneSelected,
  },
  methods: {
    handleCasSearchChange(val) {
      if (val.length > 0) {
        this.searchClass = val[val.length - 1]
      }
    },
    async handleOut() {
      let param = new URLSearchParams()
      param.append('member_id', this.member_id)
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('company_id', this.company_id)

      param.append('department_id', this.searchClass)
      param.append('user_id', this.searchUserId)
      param.append('start_time', this.start_time)
      param.append('end_time', this.end_time)
      // param.append('month', this.searchMounth)
      this.$axios({
        method: 'post',
        url: '/api/ClockInStatistics/clockin_record_down',
        data: param,
        // responseType: 'arraybuffer',
        // responseType: 'blob',
      }).then((res) => {
        console.log('res.data', res.data)
        if (res.data.code != 200) return this.$message.error(res.data.datas.msg)

        const fileName =
          '月度汇总_' + this.parseTime(new Date(), '{y}{mm}{dd}') + '.xls'

        console.log('fileName', fileName)
        let link = document.createElement('a') //创建a标签
        link.style.display = 'none' //使其隐藏
        link.href = res.data.datas.file_url //赋予文件下载地址
        link.setAttribute('download', fileName) //设置下载属性 以及文件名
        document.body.appendChild(link) //a标签插至页面中
        link.click() //强制触发a标签事件
      })
    },
    handleSearch() {
      this.currentPage = 1
      this.getMounthList()
    },
    async getDetailsList(url, item, status) {
      this.checkName = item.nickname
      this.statusShow = status
      let param = new URLSearchParams()
      param.append('member_id', this.member_id)
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('company_id', this.company_id)

      param.append('user_id', item.member_id)
      param.append('start_time', this.start_time)
      param.append('end_time', this.end_time)

      // param.append('month', this.searchMounth)
      const { data: res } = await this.$axios({
        method: 'post',
        url: `/api/${url}`,
        data: param,
      })
      if (res.code != 200) return this.$message.error(res.datas.msg)

      this.tableData2 = res.datas.data
      // this.isAdmin1 = res.datas.admin_state
      console.log('考勤详情', this.tableData2)
      if (this.tableData2.length > 0) {
        this.tableData2.forEach((item) => {
          item.statusShow = status
        })
      }
      this.dialogVisible = true
    },
    async getMounthList() {
      let param = new URLSearchParams()
      param.append('member_id', this.member_id)
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('company_id', this.company_id)

      param.append('department_id', this.searchClass)
      param.append('user_id', this.searchUserId)
      // param.append('month', this.searchMounth)
      param.append('start_time', this.start_time)
      param.append('end_time', this.end_time)

      param.append('p', this.currentPage)
      param.append('p_count', this.pageSize)
      const { data: res } = await this.$axios({
        method: 'post',
        url: '/api/ClockInStatistics/clockin_record_statistics',
        data: param,
      })
      if (res.code != 200) return this.$message.error(res.datas.msg)

      this.tableData = res.datas.listInfo
      this.total = parseInt(res.datas.count)
      // this.isAdmin1 = res.datas.admin_state
      console.log('阅读汇总', this.tableData)
    },
    // 获取部门列表
    async getClassList() {
      this.selectClassList = []
      let param = new URLSearchParams()
      param.append('member_id', this.member_id)
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('company_id', this.company_id)
      param.append('p', 1)
      param.append('p_count', 1000)
      const { data: res } = await this.$axios({
        method: 'post',
        // url: '/api/Project/project_type',
        url: '/api/Management/department',
        data: param,
      })
      if (res.code != 200) return this.$message.error(res.datas.msg)
      this.selectClassList = [...res.datas.listInfo]
      console.log('项目类型列表', this.selectClassList)
    },
    handleSearchPeopleChange(data) {
      console.log('组件传过来的搜索', data)
      this.searchUserId = data
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.getMounthList()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.getMounthList()
    },
    handleClose(done) {
      this.dialogVisible = false
    },
    handleClosed() {},
    // 解析时间
    parseTime(time, fm) {
      // 解析时间  time: 时间戳或者实践对象 fm: 格式 默认是{y}-{m}-{d} {h}:{i}:{s}
      if (arguments.length === 0) {
        return null
      }
      const format = fm || '{y}-{m}-{d} {h}:{i}:{s}'
      let date
      if (typeof time === 'object') {
        date = time
      } else {
        if (('' + time).length === 10) time = parseInt(time) * 1000
        date = new Date(time)
      }
      const formatObj = {
        y: date.getFullYear(),
        m: date.getMonth() + 1,
        d: date.getDate(),
        h: date.getHours(),
        i: date.getMinutes(),
        s: date.getSeconds(),
        a: date.getDay(),
      }
      const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
        let value = formatObj[key]
        if (key === 'a')
          return ['一', '二', '三', '四', '五', '六', '日'][value - 1]
        if (result.length > 0 && value < 10) {
          value = '0' + value
        }
        return value || 0
      })
      return time_str
    },
  },
  created() {
    this.token = localStorage.getItem('btlh_process_token') || ''
    this.member_id = localStorage.getItem('btlh_process_member_id') || ''
    this.company_id = localStorage.getItem('bthl_process_LoginCompanyId') || ''
    this.getClassList()
    this.getMounthList()
  },
}
</script>
<style lang="less" scoped>
.punch {
  height: 100%;
  // 搜索行
  .searchRow {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    .tableSearch {
      width: 20%;
      /deep/.el-input__inner {
        padding-left: 25px;
        height: 45px;
        border-radius: 24px;
        font-size: 16px;
        border: none;
        background-color: #f4f5f6;
        color: #333;
        &::placeholder {
          color: #333;
        }

        &::-webkit-input-placeholder {
          /* WebKit browsers 适配谷歌 */
          color: #333;
        }

        &:-moz-placeholder {
          /* Mozilla Firefox 4 to 18 适配火狐 */
          color: #333;
        }
      }
    }
    .btnCol {
      display: flex;
      align-items: center;
      /deep/.el-button {
        font-size: 18px;
        font-weight: normal;
        border: none;
        width: 130px;
        height: 45px;
        background: #f4a029;
        color: #fff;
        border-radius: 24px;
        padding: 0;
        margin-left: 30px;
      }
      .out {
        background: #0099ff;
      }
    }
  }
  /deep/.el-table__header {
    box-sizing: border-box;
    th {
      border-color: #40a0f2 !important;
    }
    .gutter {
      background-color: #40a0f2;
    }
  }
  // 分页行
  .pageRow {
    box-sizing: border-box;
    padding-top: 10px;
    width: 100%;
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    /deep/.el-pagination .el-select .el-input .el-input__inner {
      font-size: 14px;
    }
    /deep/.el-pagination button,
    /deep/.el-pagination span:not([class*='suffix']) {
      font-size: 14px;
    }
  }
  // 表格行
  /deep/.el-table__body {
    width: 100% !important;
  }
  .el-table::before {
    display: none;
  }
  /deep/.el-table__body-wrapper {
    box-sizing: border-box;
    border: 1px solid #f4f5f6;
  }
  // 鼠标经过效果
  /deep/.el-table--enable-row-hover .el-table__body tr:hover > td {
    background-color: #eff8ff;
  }
  // 斑马颜色
  /deep/.el-table--striped .el-table__body tr.el-table__row--striped td {
    background-color: #f4f5f6;
  }
  // 滚动条的宽度
  /deep/ .el-table__body-wrapper::-webkit-scrollbar {
    // position: absolute;
    // bottom: 0;
    width: 6px; // 横向滚动条
    height: 5px; // 纵向滚动条 必写
  }
  // 滚动条的滑块
  /deep/ .el-table__body-wrapper::-webkit-scrollbar-thumb {
    background-color: #ddd;
    border-radius: 3px;
  }
  // 滚动条的滑块
  /deep/ .el-table__body-wrapper::-webkit-scrollbar-thumb:hover {
    background-color: #ccc;
  }
  // *修改tabs样式
  /deep/.el-tabs__active-bar {
    width: 60px !important;
    margin-left: 30px;
  }
  /deep/.el-tabs {
    width: 100%;
    height: 100%;
    .el-tabs__header {
      width: 100%;
      margin-bottom: 20px;
      .el-tabs__nav-wrap {
        width: 100%;
        .el-tabs__nav-scroll {
          width: 100%;
          .el-tabs__nav {
            box-sizing: border-box;
            padding-left: 20px;
            width: 100%;
          }
        }
      }
    }
    .el-tabs__content {
      height: calc(100% - 80px);
      .el-tab-pane {
        height: 100%;
      }
    }
  }
  /deep/.el-tabs__item {
    height: 60px;
    text-align: center;
    font-size: 20px;
    color: #999999;
    font-weight: 400;
    padding-right: 100px;
    // width: 17%;
  }
  /deep/.el-tabs__item.is-active {
    color: #333 !important;
  }
  /deep/.el-tabs__item:hover {
    color: #333 !important;
  }
  /deep/.el-tabs__nav-wrap::after {
    color: #999999;
  }
  // 修改tabs样式

  // 表格操作按钮
  .tableBtn {
    padding: 0;
    // display: flex;
    justify-content: center;
    width: 80px;
    height: 32px;
    border-color: #40a0f2;
    color: #0099ff;
    border-radius: 5px;
    font-weight: normal;
  }
  // dialog弹窗
  /deep/.el-dialog {
    border-radius: 10px;
    .el-dialog__header {
      border-radius: 10px 10px 0 0;
      background-color: #f4f5f6;
      font-size: 20px;
      color: #333;
      padding-top: 20px;
      padding-bottom: 20px;
      padding-left: 40px;
    }
  }
  // 修改dia尾部按钮样式
  .dialog-footer {
    width: 100%;
    display: flex;
    padding-left: 30%;
    .el-button {
      // width: 180px;
      width: 23%;
      height: 50px;
      padding: 0;
      font-size: 20px;
      font-weight: normal;
      color: #fff;
      border: none;
      border-radius: 25px;
      background-color: #40a0f2;
      margin-bottom: 40px;
    }
    .el-button:first-child {
      margin-right: 5%;
    }
  }

  // 修改表单label
  /deep/.el-form-item__label {
    font-size: 16px;
    color: #333;
    box-sizing: border-box;
    padding-right: 50px;
    line-height: 40px;
  }
  // 修改内容
  /deep/.el-form-item__content {
    display: flex;
    // (deep)
    .el-select {
      width: 100%;
      .el-input {
        width: 80%;
      }
      .el-input__inner {
        width: 100%;
        // font-size: 18px;
        font-size: inherit;
      }
    }
    .el-input__inner {
      // font-size: 18px;
      font-size: inherit;
      width: 80%;
      height: 40px;
      border-radius: 0;
    }
    .el-textarea {
      width: 80%;
      .el-textarea__inner {
        height: 250px;
        // font-size: 18px;
        font-family: Microsoft YaHei;
        font-size: inherit;
        resize: none;
        border-radius: 0;
      }
    }
    .el-radio-group {
      height: 40px;
      width: 100%;
      display: flex;
      align-items: center;
      .el-radio {
        display: flex;
        align-items: center;
        margin-right: 15%;
      }
      .el-radio__input {
        width: 18px;
        height: 18px;
        .el-radio__inner {
          width: 18px;
          height: 18px;
        }
      }
      .el-radio__label {
        // font-size: 18px;
        font-size: inherit;
      }
    }
  }
  .currentnumber {
    cursor: pointer;
  }
  .currentnumber:hover {
    color: #0099ff;
  }
  // 修改下啦
  /deep/.classChargePeople {
    width: 160px !important;
    min-width: 160px !important;
    margin-left: 18%;
  }
  /deep/.heder40 {
    height: 56px;
  }
}
/deep/.ql-container {
  font-size: inherit;
}
.yauto {
  height: 40vh;
  overflow-y: auto;
}
.yauto::-webkit-scrollbar {
  width: 5px !important;
}
.yauto::-webkit-scrollbar-track {
  -webkit-box-shadow: inset006pxrgba(0, 0, 0, 0.3);
  border-radius: 10px;
}
/* 滚动条滑块 */
.yauto::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background: rgba(0, 0, 0, 0.1);
  -webkit-box-shadow: inset006pxrgba(0, 0, 0, 0.5);
}
// 修改人员选择(搜索栏的人员选择)
/deep/#MyTransfer {
  width: 20%;
  .filter-dash-btn {
    border: none;
    border-radius: 24px;
    background-color: #f4f5f6;
    height: 45px;
    font-size: 16px;
  }
  .checked-app-item {
    margin-left: 10px;
    border: none;
    background-color: #f4f5f6;
  }
}
/deep/.checkDia {
  .el-dialog__body {
    width: 100%;
    box-sizing: border-box;
    padding: 40px 6%;
  }
}
/deep/#MyTransfer {
  .filter-dash-btn {
    width: 100%;

    .filter-tips-default {
      width: 100%;
      padding-left: 25px;
    }
  }
}
// 去掉日期选择器图标
/deep/ .el-input__prefix {
  .el-icon-date {
    display: none;
  }
}
</style>